
export const EVENT_TYPES = [
  "Private Dining",
  "Private Party"
] as const;

export type EventType = typeof EVENT_TYPES[number];
